import { Alert, Button, Divider } from '@mui/material';
import { useFormikContext } from 'formik';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FormikCheckbox } from 'components';
import { TranslationNamespace } from 'i18n';

import { WorkingHoursScheduleDialog } from './WorkingHoursScheduleDialog';

type Props = {
  path: 'payinConfig' | 'payoutConfig';
};

export const P2PProviderWorkingHours: React.FC<Props> = ({ path }) => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.p2p_providers',
  });

  const [dialogOpen, setDialogOpen] = useState(false);

  const formik = useFormikContext<any>();
  const workingHours = formik.values?.[path]?.workingHours;
  const hasNoIntervals = !Object.values(workingHours?.weekHours || {}).some(
    (day: any) => day?.intervals?.length > 0,
  );
  const showNoIntervalsWarning = workingHours?.enabled && hasNoIntervals;

  return (
    <Fragment>
      <Divider sx={{ mt: 2, mb: 2 }}>{t('fields.working_hours_title')}</Divider>
      <FormikCheckbox
        label={t('fields.working_hours_enabled')}
        name={`${path}.workingHours.enabled`}
        tooltip={t('fields.working_hours_enabled_description')}
      />
      {showNoIntervalsWarning && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          {t('fields.working_hours_no_intervals_warning')}
        </Alert>
      )}
      <Button
        variant="outlined"
        sx={{ alignSelf: 'flex-start' }}
        onClick={() => setDialogOpen(true)}
      >
        {t('fields.working_hours_edit_schedule_button')}
      </Button>

      <WorkingHoursScheduleDialog
        open={dialogOpen}
        path={path}
        onClose={() => setDialogOpen(false)}
      />
    </Fragment>
  );
};
